import { CustomElement } from '@aurelia/runtime-html';
export const name = "application-link";
export const template = "<template>\n    <input type=\"text\" value.bind=\"value\" class=\"form-control hidden-print\" placeholder.bind=\"placeholder\"\n        tabindex.bind=\"tabindex\" ref=\"input\" />\n        <div if.bind=\"value\" class=\"textarea visible-print\" style=\"white-space: pre-wrap\">${value}</div>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
